import { HttpMethods } from "../enums/HttpMethods";
import { StoredFields } from "../enums/StoredFields";
import { DataWrapper } from "../interfaces/DataWrapper";
import { Disclaimer } from "../interfaces/Disclaimer";
import ContentFeedService from "./contentFeed.service";

class DisclaimersService {
  public static getImage(): Promise<Disclaimer> {
    return ContentFeedService.sendRequest<DataWrapper<Disclaimer>>(HttpMethods.GET, StoredFields.IMAGE_DISCLAIMER)
      .then((wrappedDisclaimer: DataWrapper<Disclaimer>) => wrappedDisclaimer.data)
      .catch((error: Error) => {
        throw error;
      });
  }

  public static getVariation(): Promise<Disclaimer> {
    return ContentFeedService.sendRequest<DataWrapper<Disclaimer>>(HttpMethods.GET, StoredFields.VARIATION_DISCLAIMER)
      .then((wrappedDisclaimer: DataWrapper<Disclaimer>) => wrappedDisclaimer.data)
      .catch((error: Error) => {
        throw error;
      });
  }
}

export default DisclaimersService;
